import { cloneDeep } from "lodash";
import { Project } from "models/project.model";
import React, { useEffect, useState } from "react";
import UserSettingsReportingItem from "./UserSettingsReportingItem";

const UserSettingsReporting: React.FC<{
  modifiedCurrUser: any;
  setModifiedCurrUser: any;
  setOpenListModal: any;
  projects: Project[];
  setFormDirty: any;
  formDirty: string[];
}> = ({
  modifiedCurrUser,
  setModifiedCurrUser,
  setOpenListModal,
  projects,
  setFormDirty,
  formDirty,
}) => {
  const [
    isSuperAdminForThisModule,
    setIsSuperAdminForThisModule,
  ] = useState<boolean>(false);

  const handleChange = (type: string) => {
    if (type === "setSuperAdmin") {
      if (!formDirty.includes("superadminreporting")) {
        let newList = formDirty;
        newList.push("superadminreporting");
        setFormDirty(newList);
      }

      let updatedU = cloneDeep(modifiedCurrUser);
      if (isSuperAdminForThisModule) {
        updatedU.privileges["reporting"] = [];
        setIsSuperAdminForThisModule(false);
      } else {
        updatedU.privileges["reporting"] = [
          {
            details: { type: "project" },
            id: null,
            module: "reporting",
            role: "superadmin",
          },
        ];
        setIsSuperAdminForThisModule(true);
      }
      setModifiedCurrUser(updatedU);
    }
  };

  const updateProjectPrivilege = (projectCode: string, role: string) => {
    let newDirtyList = cloneDeep(formDirty);
    newDirtyList.push("reporting-" + projectCode);
    setFormDirty(newDirtyList);

    let newUser = cloneDeep(modifiedCurrUser);
    newUser.privileges["reporting"].map((priv: any) => {
      if (priv.details["projectCode"] === projectCode) {
        priv.role = role;
      }
    });
    setModifiedCurrUser(newUser);
  };

  const removePrivilege = (projectCode: string) => {
    let newDirtyList = cloneDeep(formDirty);
    newDirtyList.push("reporting-" + projectCode);
    setFormDirty(newDirtyList);

    let newUser = cloneDeep(modifiedCurrUser);
    let newListPrivilege = newUser.privileges["reporting"];
    newListPrivilege = newUser.privileges["reporting"].filter(
      (priv: any) => priv.details["projectCode"] !== projectCode
    );
    newUser.privileges["reporting"] = newListPrivilege;
    setModifiedCurrUser(newUser);
  };

  useEffect(() => {
    if (
      modifiedCurrUser &&
      modifiedCurrUser.privileges &&
      modifiedCurrUser.privileges["reporting"] &&
      modifiedCurrUser.privileges["reporting"].length > 0
    ) {
      if (modifiedCurrUser.privileges["reporting"][0].role === "superadmin") {
        setIsSuperAdminForThisModule(true);
      }
    }
  }, []);

  return (
    <div className="user-settings-reporting">
      <h3>— general settings</h3>

      <i className="italic">Reporting status</i>
      <div className="toggle-container">
        <div className="toggle">
          <input
            type="checkbox"
            id="active"
            className="toggle-input"
            onChange={() => handleChange("setSuperAdmin")}
            checked={isSuperAdminForThisModule}
          />
          <div className="toggle-switcher"></div>
        </div>
        <span className="label">Grant Meridiam hub super admin privilege</span>
      </div>
      <div className={`state ${isSuperAdminForThisModule ? "warn" : ""}`}>
        {isSuperAdminForThisModule && (
          <>
            <i className="fas fa-exclamation-circle"></i>
            Please be aware that user with super admin access will have access
            to all SPV's Reporting + Fund completion.
          </>
        )}
      </div>

      {!isSuperAdminForThisModule && (
        <>
          <div className="separator"></div>

          <div className="title-with-btn">
            <h3>— user privileges by project</h3>
            <button
              className="btn btn-select btn-primary"
              type="button"
              onClick={() => setOpenListModal("project-reporting")}
            >
              <span className="btn-label">Add/remove projects</span>
              <span className="btn-icon">
                <i className={`fas fa-right`}></i>
              </span>
            </button>
          </div>

          <ul className="list">
            <li className="row filters">
              <div className="project">
                <i className="label">Project</i>
              </div>
              <div className="group">
                <i className="label">Role</i>
              </div>
              <div className="delete">
                <i className="label">Delete</i>
              </div>
            </li>

            {!!modifiedCurrUser &&
              !!modifiedCurrUser.privileges &&
              !!modifiedCurrUser.privileges["reporting"] &&
              modifiedCurrUser.privileges["reporting"].length > 0 &&
              modifiedCurrUser.privileges[
                "reporting"
              ].map((privilege: any, idx: number) => (
                <UserSettingsReportingItem
                  key={`projectK-${idx}`}
                  privilege={privilege}
                  projects={projects}
                  updateProjectPrivilege={updateProjectPrivilege}
                  formDirty={formDirty}
                  removePrivilege={removePrivilege}
                />
              ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default UserSettingsReporting;
